import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../helpers/auth';
import AdminLogin from '../components/AdminLogin';

const AdminPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const authenticated = await authApi.verifyToken();
      setIsAuthenticated(authenticated);
      setLoading(false);
      
      if (authenticated) {
        navigate('/admin/dashboard');
      }
    };

    checkAuth();
  }, [navigate]);

  const handleLogin = () => {
    setIsAuthenticated(true);
    navigate('/admin/dashboard');
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      {!isAuthenticated && (
        <AdminLogin onLogin={handleLogin} />
      )}
    </div>
  );
};

export default AdminPage;